<template>
  <section
    class="section-intro-image tw-flex tw-h-[65vh] tw-items-end tw-justify-center tw-bg-cover tw-bg-center tw-pb-24"
    :class="[company.company_key === 'jacksonsproperty' ? `tw-h-[75vh]` : '']"
    :style="[
      `background-image: url(${isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage});`,
      doesCircleCtaExist ? 'padding-top: 720px' : '',
    ]"
  >
    <div class="container" style="z-index: 3">
      <div class="tw-max-w-2xl">
        <library-title
          v-if="company.company_key !== 'jacksonsproperty'"
          tag="h1"
          :text="vars.titleText"
          class="tw-mb-6 tw-text-5xl !tw-text-white lg:!tw-text-6xl"
          style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2)"
        />
        <h2 v-else class="tw-mb-6" style="color: var(--c-text_secondary) !important">{{ vars.titleText }}</h2>
        <p
          v-if="vars.descriptionText"
          class="font-arial tw-mb-6 !tw-text-white lg:tw-mb-10"
          style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2)"
        >
          {{ vars.descriptionText }}
        </p>
        <div
          v-if="vars.buttons1LabelText.length > 0"
          class="tw-grid tw-grid-cols-1 tw-items-center tw-gap-4 lg:tw-grid-cols-2"
          style="z-index: 3"
        >
          <div v-for="(button, index) in buttons" :key="`button-${index}`">
           <nuxt-link
  :to="button.href"
  :external="true"
  class="inline-flex items-center justify-center  !tw-py-0.5 transition-all duration-200"
  :class="{
    'pxp-search-properties-btn': button.type === 'primary',
    'pxp-primary-cta pxp-animate': button.type === 'secondary',
  }"
  :style="`
    background-color: var(--${button.background});
    color: var(--${button.text});
    ${button.type === 'secondary' ? `border: 1px solid var(--${button.text});` : ''}
  `"
>
  {{ button.label }}
</nuxt-link>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'SectionIntro',

  mixins: [ComponentMixin],

  data() {
    return {
      doesCircleCtaExist: false,
    };
  },

  computed: {
    buttons() {
      return this.groupedVariables.buttons;
    },
  },

  mounted() {
    const circleCTA = document.getElementById('theme3-circle-cta');
    if (circleCTA) {
      this.doesCircleCtaExist = true;
    }
  },
});
</script>

<style scoped>
.section-intro-image {
  position: relative;
}

.section-intro-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3); /* Black background with 50% opacity */
  z-index: 1;
}
</style>
